import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=46d9e359"
import script from "./CreateEmail.vue?vue&type=script&lang=js"
export * from "./CreateEmail.vue?vue&type=script&lang=js"
import style0 from "./CreateEmail.vue?vue&type=style&index=0&id=46d9e359&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports